import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import './scss/RecentView.scss'
import MemberImage from "../Global/MemberImage";
import StarFill from "../icons/StarFill";
import { fetchStarredBoards } from "../../redux/Slices/boardsSlice";
import { config } from "../../config";
import { fetchUser } from "../../redux/Slices/thunks";
import MoreMembersCount from "../Global/MoreMembersCount";
import { ChevronRight, Dashboard } from "../icons";
import { api } from "../../utils/apiUtils";
import BoardVisibilityIcon from "../Global/BoardVisibilityIcon";

const TopBoards = ({ type, boards }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const scrollContainerRef = useRef(null);
    const [showLeftShadow, setShowLeftShadow] = useState(false);
    const [showRightShadow, setShowRightShadow] = useState(false);

    const { user } = useSelector((state) => state.user);
    const isUserLoaded = user && user.user;
    const slicedBoards = boards || [];

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (!container) return;

        const handleScrollEvent = () => {
            const { scrollLeft, scrollWidth, clientWidth } = container;
            setShowLeftShadow(scrollLeft > 0);
            setShowRightShadow(scrollLeft + clientWidth < scrollWidth - 1);
        };

        container.addEventListener('scroll', handleScrollEvent);
        window.addEventListener('resize', handleScrollEvent);
        handleScrollEvent();

        const resizeObserver = new ResizeObserver(() => {
            handleScrollEvent();
        });
        resizeObserver.observe(container);

        return () => {
            container.removeEventListener('scroll', handleScrollEvent);
            window.removeEventListener('resize', handleScrollEvent);
            resizeObserver.disconnect();
        };
    }, [slicedBoards]);

    const handleScroll = (direction) => {
        if (scrollContainerRef.current) {
            const scrollAmount = 600;
            const container = scrollContainerRef.current;
            const newScrollLeft = direction === 'left'
                ? container.scrollLeft - scrollAmount
                : container.scrollLeft + scrollAmount;

            container.scrollTo({
                left: newScrollLeft,
                behavior: 'smooth'
            });
        }
    };

    const toggleStar = async (e, boardId, shortId) => {
        e.preventDefault();
        e.stopPropagation();

        if (!isUserLoaded) {
            console.warn('User data not loaded yet');
            return;
        }

        try {
            const isStarred = user?.user?.starredBoards?.includes(boardId);
            const action = isStarred ? 'remove' : 'add';

            // Use the standard api utility which handles CSRF and other headers
            await api.put(`${config.API_URI}/v1/users/me/stared`, {
                boardId: shortId,
                action
            });

            // Refresh data in Redux store
            dispatch(fetchStarredBoards());
            dispatch(fetchUser());
        } catch (error) {
            console.error('Error toggling star status:', error);
        }
    };

    return (
        <div className={`carousel-container ${showLeftShadow ? 'show-left-shadow' : ''} ${showRightShadow ? 'show-right-shadow' : ''}`}>
            {showLeftShadow && (
                <button
                    className="carousel-btn left"
                    onClick={() => handleScroll('left')}
                    aria-label="Scroll left"
                >
                    <ChevronRight />
                </button>
            )}

            <div className="recent-carousel" ref={scrollContainerRef}>
                {slicedBoards.map(board => {
                    const members = (board.members || []).filter(member => member._id);
                    const isStarred = user?.user?.starredBoards?.includes(board._id);
                    const coverColor = Array.isArray(board?.cover?.coverColor) && board.cover.coverColor.length > 2
                        ? board.cover.coverColor[2]
                        : null;

                    return (
                        <div
                            key={board._id}
                            className="recent-card"
                            onClick={() => navigate(board.permalink)}
                        >
                            <div className="recent-card-cover">
                                {board?.cover?.url || board?.cover?.sizes?.medium ? (
                                    <img
                                        src={board?.cover?.sizes?.medium || board?.cover?.url}
                                        alt={board.title}
                                        className="cover-img"
                                        loading="lazy"
                                    />
                                ) : (
                                    <div
                                        className="cover-placeholder"
                                        style={coverColor ? { background: coverColor } : {}}
                                    />
                                )}
                                <button
                                    className={`card-actions-btn star-btn ${isStarred ? 'starred' : ''}`}
                                    onClick={(e) => toggleStar(e, board._id, board.shortId)}
                                    title={isStarred ? 'Remove from favorites' : 'Add to favorites'}
                                >
                                    {isUserLoaded && (
                                        <>
                                            {!isStarred ? (
                                                <span className="material-symbols-outlined">kid_star</span>
                                            ) : (
                                                <StarFill color="#FFD700" size={16} />
                                            )}
                                        </>
                                    )}
                                </button>
                            </div>

                            <div className="recent-card-content">
                                <div className="recent-card-icon">
                                    <BoardVisibilityIcon visibility={board.visibility} size={16} />
                                </div>

                                <div className="card-title-rows">
                                    <div className="card-title">{board.title || 'Untitled'}</div>
                                </div>

                                {/* <div className="recent-card-footer">
                                    <div className="user-info">
                                        <span className="stats-text">
                                            {(board.cardsCount || 0)} cards
                                        </span>
                                        <div className="members-info">
                                            <MemberImage
                                                members={members}
                                                type={'board'}
                                                size={20}
                                                displayMembersLimit={3}
                                                uniqId={board.shortId + '-starred'}
                                            />
                                            <MoreMembersCount members={members} boardId={board.shortId} uniqid={board.shortId + '-starred'} />
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    );
                })}
            </div>

            {showRightShadow && (
                <button
                    className="carousel-btn right"
                    onClick={() => handleScroll('right')}
                    aria-label="Scroll right"
                >
                    <ChevronRight />
                </button>
            )}
        </div>
    );
};

export default TopBoards;